import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiGetTrackingReport } from "services/TargetService";

export const getTrackingReportData = createAsyncThunk(
  "trackingReport/data/getTrackingReportData",
  async (data) => {
    try {
      const res = await apiGetTrackingReport({
        from: data.start_date,
        to: data.end_date,
        user_id: data.mr_id,
        per_page: data.pageSize,
        page: data.pageIndex,
        download: "",
      });

      return {
        items: res.data.items,
        meta: {
          mr_id: data.mr_id,
          ...res.data.meta,
        },
      };
    } catch (error) {
      console.error("Server Error:", error);
      throw new Error(error.message);
    }
  }
);

export const initialTableData = {
  total: 0,
  pageIndex: 1,
  pageSize: 10,
  query: "",
  sort: { order: "", key: "" },
};

const initialState = {
  loading: false,
  data: [],
  tableData: { ...initialTableData },
  dateRange: { start_date: "", end_date: "" },
  error: null,
};

const dataSlice = createSlice({
  name: "trackingReport/data",
  initialState,
  reducers: {
    reset: () => initialState,
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setData(state, action) {
      state.data = action.payload;
    },
    updateTable(state, action) {
      state.tableData = {
        ...state.tableData,
        ...action.payload,
      };
    },
    setDateRange(state, action) {
      state.dateRange = action.payload;
      state.tableData.pageIndex = 1;
    },
    setError(state, action) {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTrackingReportData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTrackingReportData.fulfilled, (state, action) => {
        const payload = action.payload;
        const meta = payload?.meta || {};
        state.data = payload?.items || [];
        state.tableData.total = meta.totalItems || 0;
        state.tableData.pageIndex = meta.currentPage || 1;
        state.tableData.pageSize = meta.perPage || 10;
        state.loading = false;
      })
      .addCase(getTrackingReportData.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      });
  },
});

export const {
  reset,
  setLoading,
  setData,
  updateTable,
  setDateRange,
  setError,
} = dataSlice.actions;

export default dataSlice.reducer;
